import React, { useEffect, useState } from "react";
import QuestionDetailModal from "../../components/Modal/QuestionDetailModal";
import { Radio } from "@mui/material";
import MultiAddedInput from "./MultiInput";
import GeoSearch from "../../components/PropertyComponent/GeoSearch";
import SignatureCanvas from "react-signature-canvas";

export default function CG_SingleQuestion({ index, item, handleChangeTextAndCheckbox, answers, setResetTrigger, resetTrigger }) {
    const [tags, setTags] = useState([]);

    const sigCanvasRef = React.useRef(null);
    const className = "tw-w-full tw-px-3 tx-py-1 tw-bg-white tw-border-1 tw-rounded-lg tw-outline-none";
    useEffect(() => {
        setTags([]);
    }, [resetTrigger]);
    return (
        <div key={index} className="tw-mb-6">
            <div className="tw-flex tw-gap-2 tw-text-lg">
                <p className="tw-text-lg tw-mb-2 tw-leading-none">{item.question}</p>
                <QuestionDetailModal item={item} />
            </div>
            {(item.type === "address" || item.type === "Address") && (
                <GeoSearch
                    address={answers.find((ans) => ans.question_id === item.question_id)?.answer}
                    setAddress={(value) => handleChangeTextAndCheckbox(value, item.question_id)}
                    className={className}
                />
            )}
            {item.type === "signature" && (
                <SignatureCanvas
                    ref={sigCanvasRef}
                    onEnd={() => {
                        handleChangeTextAndCheckbox(sigCanvasRef.current.toDataURL(), item.question_id);
                    }}
                    penColor="#232D8E"
                    canvasProps={{
                        className: "tw-w-full tw-border tw-rounded-lg tw-border-gray-300 tw-bg-white",
                        style: {
                            height: 300,
                            backgroundColor: "#fffff",
                        },
                    }}
                />
            )}
            {(item?.type === "checkbox" ||
                item?.type === "single-checkbox" ||
                item?.type === "singlecheckbox" ||
                item?.type === "multiselect-checkbox" ||
                item.type === "multicheckbox") && (
                <div className=" tw-flex tw-flex-col tw-gap-2">
                    {item.values.map((option, idx) => (
                        <div key={idx} className=" tw-flex tw-items-center tw-gap-3 tw-border   tw-bg-white tw-p-3 tw-rounded-lg">
                            <Radio
                                checked={answers.find((ans) => ans.question_id === item.question_id)?.answer === option}
                                onChange={() => handleChangeTextAndCheckbox(option, item.question_id)}
                                value={item}
                                name="color-radio-button-demo"
                                className={`${answers.find((ans) => ans.question_id === item.question_id)?.answer === option && "tw-text-secondary"}`}
                                sx={{
                                    "&.Mui-checked": {
                                        color: "theme(colors.primary) !important", // Custom Tailwind primary color
                                    },
                                }}
                            />
                            <span>{option}</span>
                        </div>
                    ))}
                </div>
            )}
            {(item.type === "text" ||
                item.type === "Date" ||
                item.type === "multitext" ||
                item.type === "textoptional" ||
                item.type === "typeoptional" ||
                item.type === "nultiline" ||
                item.type === "multiline" ||
                item.type === "number" ||
                item.type === "date" ||
                item.type === "Date" ||
                item.type === "datetype" ||
                item.type === "dateType" ||
                item.type === "time") && (
                <input
                    type={`${
                        item.type === "datetype"
                            ? "date"
                            : item.type === "number"
                              ? "number"
                              : item.type === "date" || item.type === "Date" || item.type === "time"
                                ? "date"
                                : "text"
                    }`}
                    onInput={(e) => {
                        if (item.type === "number") {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                        }
                    }}
                    placeholder="Write your answer"
                    className="tw-w-full tw-p-3 tw-bg-white tw-border-1 tw-rounded-lg tw-outline-none"
                    value={answers.find((ans) => ans.question_id === item.question_id)?.answer || ""}
                    onChange={(e) => handleChangeTextAndCheckbox(e.target.value, item.question_id)}
                />
            )}

            {item.type === "list" && (
                <MultiAddedInput
                    // setList={(value) => handleChangeTextAndCheckbox(value, item.question_id)}
                    handleChangeTextAndCheckbox={handleChangeTextAndCheckbox}
                    item={item}
                    setTags={setTags}
                    tags={tags}
                />
            )}
        </div>
    );
}
